import { defineStore } from 'pinia';
import SalesGoalsAPI from 'dashboard/api/salesGoals';

export const useSalesGoalsStore = defineStore('salesGoals', {
  state: () => ({
    goals: [],
    uiFlags: {
      fetchingList: false,
      creatingItem: false,
      updatingItem: false,
      deletingItem: false,
    },
  }),

  getters: {
    getGoals: state => state.goals,
    getGoalForAgent: state => agentId =>
      state.goals.find(g => g.agent_id === agentId),
  },

  actions: {
    async fetchGoals(params = {}) {
      this.uiFlags.fetchingList = true;
      try {
        const { data } = await SalesGoalsAPI.get(params);
        this.goals = data;
      } finally {
        this.uiFlags.fetchingList = false;
      }
    },

    async createGoal(payload) {
      this.uiFlags.creatingItem = true;
      try {
        const { data } = await SalesGoalsAPI.create(payload);
        this.goals.push(data);
        return data;
      } finally {
        this.uiFlags.creatingItem = false;
      }
    },

    async updateGoal(id, payload) {
      this.uiFlags.updatingItem = true;
      try {
        const { data } = await SalesGoalsAPI.update(id, payload);
        const idx = this.goals.findIndex(g => g.id === id);
        if (idx !== -1) this.goals[idx] = data;
        return data;
      } finally {
        this.uiFlags.updatingItem = false;
      }
    },

    async fetchGoalsByAgent(agentId, year) {
      const { data } = await SalesGoalsAPI.get({ agent_id: agentId, year });
      return data;
    },

    async deleteGoal(id) {
      this.uiFlags.deletingItem = true;
      try {
        await SalesGoalsAPI.delete(id);
        this.goals = this.goals.filter(g => g.id !== id);
      } finally {
        this.uiFlags.deletingItem = false;
      }
    },
  },
});
